import React, { useMemo, useState } from 'react';

import {
  HorizontalCardWithTitle,
  Loader,
  TextInput as RawTextInput,
} from '@randstad-lean-mobile-factory/react-components-core';
import { Cross, Search } from '@randstad-lean-mobile-factory/react-components-ui-shared';

import ErrorMessage from 'src/Components/ErrorMessage';
import Filet from 'src/Components/Filet';
import InputLabel from 'src/Components/InputLabel';
import { useGetAgencyListWithBrandCodes } from 'src/Hooks/CustomRandy/useGetAgencyListWithBrandCodes';
import history from 'src/Utils/history';

import { useIsProductionEnvironment } from '../../../../Hooks/Environment/useIsProductionEnvironment';
import { CustomRandySection, CustomRandySubSection, URL } from '../../CustomRandy.types';

import Styles from './AgencyListScreen.module.scss';

const AgencyListScreen = () => {
  const { data, isLoading, error } = useGetAgencyListWithBrandCodes();
  const { isProd } = useIsProductionEnvironment();

  const [filterQuery, setFilterQuery] = useState('');

  const filteredData = useMemo(() => {
    const mappedData = data?.agencies.flatMap(agencies => {
      return agencies.agencies.map(a => {
        return { brand: agencies.brandCode, agency: a };
      });
    });
    return mappedData?.filter(agency => {
      const filter = filterQuery
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^A-Za-z0-9 ]/g, '')
        .toUpperCase();

      return (
        (agency.agency
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^A-Za-z0-9 ]/g, '')
          .toUpperCase()
          .includes(filter) ||
          agency.brand
            ?.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^A-Za-z0-9 ]/g, '')
            .toUpperCase()
            .includes(filter)) ??
        []
      );
    });
  }, [data, filterQuery]);

  return (
    <div className={Styles.AgencyListScreen}>
      <h2 className={Styles.Title}>mes agences</h2>
      {isLoading && <Loader heightInRem={2} darkMode />}
      {error && <ErrorMessage error={error} />}
      {data && !data.agencies.length && "vous n'êtes rattaché à aucune agence"}
      {data && data.agencies.length > 0 && (
        <>
          <div className={Styles.Filters}>
            <InputLabel label="trouver une agence">
              <RawTextInput
                placeholder="ex: MGL"
                rightIcon={filterQuery ? <Cross className={Styles.Cross} /> : undefined}
                value={filterQuery}
                onChange={event => {
                  setFilterQuery(event.currentTarget.value);
                }}
                onRightIconClick={() => {
                  setFilterQuery('');
                }}
                leftIcon={<Search className={Styles.Icon} />}
              />
            </InputLabel>
          </div>

          <Filet />

          <div>
            {!filteredData?.length && `aucune de vos agences ne correspond à « ${filterQuery} »`}
            {filteredData?.map(agency => (
              <HorizontalCardWithTitle
                key={`${agency.agency}${agency.brand}`}
                title={`agence ${agency.agency} ${
                  agency.brand && !isProd ? '(marque ' + agency.brand + ')' : ''
                }`}
                className={Styles.AgencyCard}
                onClick={() => {
                  history.push(
                    `/${URL}/${CustomRandySection.links}/${CustomRandySubSection.agency}/${agency.agency}/${agency.brand}`
                  );
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AgencyListScreen;
